
import Vue, { PropType } from 'vue'
import { ErrorDetail } from '@/api'

import Multiselect from 'vue-multiselect'

export type Option = {
  name: string;
  value: string;
}

export type DataType = {
  focused: boolean;
}

export default Vue.extend({
  name: 'BaseSelectorForm',

  components: {
    Multiselect
  },

  props: {
    value: String as PropType<string>,
    label: String as PropType<string>,
    resource: String as PropType<string>,
    propkey: String as PropType<string>,
    placeholder: String as PropType<string>,
    disabled: Boolean as PropType<boolean>,
    options: Array as PropType<Array<Option>>,
  },

  data(): DataType {
    return {
      focused: false,
    }
  },

  computed: {
    bindSelected: {
      get (): Option | undefined {
        return this.options.find((op: Option): boolean => {
          return op.value === this.value
        })
      },

      set (value: Option): void {
        this.$emit('input', value?.value || '')
      }
    },

    hasValidationError(): boolean {
      if (this.$error.errDetails === undefined) return false
      return this.$error.errDetails.some((ed: ErrorDetail) => {
        return ed.resource === this.resource && ed.field === this.propkey
      })
    },

    validationErrorMsg(): string | undefined {
      if (this.$error.errDetails === undefined) return

      return this.$error.errDetails.filter((ed: ErrorDetail) => {
        return ed.resource === this.resource && ed.field === this.propkey
      }).map((ed: ErrorDetail) => ed.message).join(', ')
    }
  },

  methods: {
    changeFocused(): void {
      this.focused = !this.focused
    },
  }
})
